import type { PropsWithChildren } from 'react';

export function Layout({ children }: PropsWithChildren) {
  return <main className="grow p-xl bg-level-01/full">{children}</main>;
}

Layout.displayName = 'Layout';
